import React, { useEffect, useState } from "react";
import {
  Badge,
  Button,
  Card,
  CardImg,
  CardImgOverlay,
  Col,
  Row,
} from "reactstrap";
// import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import "./TouristAttractions.css";
import everest from "../../../../assets/images/Travel/sagarmatha.png";
import Swoyambh from "../../../../assets/images/Travel/swambhu.png";
import kathmandu from "../../../../assets/images/Travel/kathmandu.png";
import { Link } from "react-router-dom";
import { createSlug } from "../../../../utilis/slugUtilis";

const TouristAttractions = ({ homeData }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(3); // Default: 3 items per page
  const [currentSlide, setCurrentSlide] = useState(0);

  // Update itemsPerPage based on screen size
  useEffect(() => {
    const updateItemsPerPage = () => {
      const isSmallScreen = window.innerWidth < 576; // Bootstrap's breakpoint for small screens
      setItemsPerPage(isSmallScreen ? 1 : 3);
    };

    updateItemsPerPage(); // Initial check
    window.addEventListener("resize", updateItemsPerPage);

    return () => {
      window.removeEventListener("resize", updateItemsPerPage);
    };
  }, []);

  // Get all packages for the "All" filter or the selected country's packages
  const selectedPackages =
    currentStep === 0
      ? homeData?.attractions?.flatMap((attraction) => attraction.packages) ||
        []
      : homeData?.attractions[currentStep - 1]?.packages || [];

  // Number of slides needed
  const totalSlides = Math.ceil(selectedPackages.length / itemsPerPage);

  const nextSlide = () => {
    if (currentSlide < totalSlides - 1) {
      setCurrentSlide(currentSlide + 1);
    }
  };

  const prevSlide = () => {
    if (currentSlide > 0) {
      setCurrentSlide(currentSlide - 1);
    }
  };

  // Get the packages for the current slide
  const visiblePackages = selectedPackages.slice(
    currentSlide * itemsPerPage,
    currentSlide * itemsPerPage + itemsPerPage
  );

  return (
    <div className="mb-3 p-0">
      <h2 className="text-center mb-4">Major Tourist Attractions</h2>
      <Row className="align-items-center mb-4">
        {/* Filter Buttons */}
        <Col lg={6} xs={12} className="mb-3 mb-lg-0">
          <div className="d-flex flex-wrap gap-2">
            <Button
              color="btn-outline-dark"
              className={`btn-sm btn-outline-dark ${
                currentStep === 0 ? "active" : ""
              }`}
              onClick={() => {
                setCurrentStep(0);
                setCurrentSlide(0); // Reset slide
              }}
            >
              All
            </Button>
            {homeData?.attractions?.map((country, index) => {
              // Only render the button if the 'packages' array is not empty or null
              if (country.packages && country.packages.length > 0) {
                return (
                  <Button
                    key={country.id}
                    color="btn-outline-dark"
                    className={`btn-sm btn-outline-dark ${
                      currentStep === index + 1 ? "active" : ""
                    }`}
                    onClick={() => {
                      setCurrentStep(index + 1);
                      setCurrentSlide(0); // Reset slide
                    }}
                  >
                    {country.name}
                  </Button>
                );
              }
              // Return null if packages is empty or null
              return null;
            })}
          </div>
        </Col>
        {/* Navigation Buttons */}
        <Col
          lg={6}
          xs={12}
          className="d-flex justify-content-lg-end justify-content-center gap-3"
        >
          <Button
            color="btn-outline-dark"
            className="rounded-circle btn-sm"
            onClick={prevSlide}
            disabled={currentSlide === 0}
          >
            <i className="bx bx-chevron-left" style={{ fontSize: "20px" }}></i>
          </Button>
          <Button
            color="btn-dark"
            className="rounded-circle btn-sm"
            onClick={nextSlide}
            disabled={currentSlide === totalSlides - 1}
          >
            <i className="bx bx-chevron-right" style={{ fontSize: "20px" }}></i>
          </Button>
        </Col>
      </Row>

      {/* Display "No data" if there are no packages */}
      {visiblePackages.length === 0 ? (
        <div
          className="text-center justify-content-center align-content-center text-info"
          style={{ height: "200px" }}
        >
          <p>No data available for this selection.</p>
        </div>
      ) : (
        <Row className="">
          {visiblePackages.map((pkg) => (
            <Col lg={4} md={6} sm={12} xs={12} key={pkg.id}>
              <Card
                inverse
                className="shadow-sm"
                style={{ borderRadius: "1rem" }}
              >
                {/* Wrap the Card component with the Link to enable navigation */}
                <Link
                  to={createSlug(`/packages/${pkg.name}`)} // Fix the slug here
                  style={{ textDecoration: "none" }}
                >
                  <CardImg
                    alt={pkg.name}
                    src={pkg.banner_image_url}
                    style={{
                      borderRadius: "1rem",
                      objectFit: "cover",
                      height: "250px",
                    }}
                    width="100%"
                  />
                  <CardImgOverlay className="d-flex flex-column justify-content-end align-items-start text-white p-3">
                    <h6 className="text-white">{pkg.region}</h6>
                    <h5 className="text-white">{pkg.name}</h5>
                  </CardImgOverlay>
                </Link>
              </Card>
            </Col>
          ))}
        </Row>
      )}
    </div>
  );
};
export default TouristAttractions;
